import React, { useEffect, useState } from 'react';
import api from '../../services/api';
import { Link } from 'react-router-dom';

const SectionList = () => {
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(true);

  // Define a constante com a nova URL secreta do painel visual
  const CMS_BASE_URL = '/jb-acesso-master-control-cms';

  const fetchSections = async () => {
    try {
      const response = await api.get('/admin/sections');
      setSections(response.data.data);
    } catch (error) {
      console.error('Erro ao carregar seções:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSections();
  }, []);

  const handleDelete = async (id) => {
    if (window.confirm('Tem certeza que deseja excluir esta seção definitivamente?')) {
      try {
        await api.delete(`/admin/sections/${id}`);
        fetchSections();
      } catch (error) {
        alert('Erro ao excluir seção');
      }
    }
  };

  if (loading) return <div>Carregando seções...</div>;

  return (
    <div className="card shadow-sm border-0">
      <div className="card-header bg-white py-3 d-flex justify-content-between align-items-center">
        <h5 className="mb-0 fw-bold">Seções da Onepage</h5>
        <Link to={`${CMS_BASE_URL}/sections/new`} className="btn btn-success btn-sm d-none">
          + Criar Nova Seção
        </Link>
      </div>
      <div className="table-responsive">
        <table className="table table-hover align-middle mb-0">
          <thead className="table-light">
            <tr>
              <th>Ordem</th>
              <th>Título</th>
              <th>Status</th>
              <th className="text-end">Ações</th>
            </tr>
          </thead>
          <tbody>
            {sections.map((s) => (
              <tr key={s.id} style={{ opacity: s.is_active ? 1 : 1 }}>
                <td>{s.section_order}</td>
                <td><strong>{s.navbar_title}</strong><br/><small className="text-muted">{s.slug}</small></td>
                <td>
                  <span 
                    className={`badge ${s.is_active ? 'bg-success' : 'bg-danger'} px-2 py-1`}
                    style={{ fontSize: '0.85rem', fontWeight: '500' }}
                  >
                    {s.is_active ? '● Visível' : '○ Oculto'}
                  </span>
                </td>
                <td className="text-end">
                  <div className="btn-group">
                    <Link to={`${CMS_BASE_URL}/sections/edit/${s.id}`} className="btn btn-sm btn-outline-primary">
                      Editar
                    </Link>
                    <button 
                      onClick={() => handleDelete(s.id)}
                      className="btn btn-sm btn-outline-danger"
                    >
                      Excluir
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SectionList;
